import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { IconSearch, PopoverTrigger, ButtonIcon, IconChevronDown, IconChevronUp, PopoverNavigation, PopoverNavigationItem, PopoverNavigationLink, Backdrop } from '@spotify-internal/encore-web';
import { useTracking } from '../../Tracking';
import { RequireFeatureFlag } from '../../Auth/RequireFeatureFlag';
import { useCurrentUser } from '../../../@mrkt/useCurrentUser';
import { useLayoutContext } from '../LayoutState';
import { Link, ResponsiveLogo, Modal } from '../../ui';
import { useScrollYPosition } from '../../utils';
import { NavSideMenu } from './NavSideMenu';
import { OpenSideMenuButton } from './NavSideMenu.styles';
import { NavBarWrapper, LogoArea, LinksArea, ActionsArea, MenuButtonArea, LoginButton, ClaimButton, MenuLink, MenuCategory, StyledListItemWithMargin, StyledListItemNoMargin } from './NavBar.styles';
import { USE_SEARCH } from './constants';
import { isHelpLive } from '../../Help/util';
import { useRouter } from 'next/router';
import { useT } from '@mrkt/features/i18n';
import { NavBarLanguageItem, SideMenuLanguageOnboarding } from './Language';
import { getAccountsDomain } from '@mrkt/features/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SIDE_MENU_TRIGGER_BREAKPOINT = 992;
var TRACK_CAT = 'Top Nav';
var MENU_CLOSE_DELAY = 500; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var MenuCategoryLink = /*#__PURE__*/React.forwardRef(function (_ref, _) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(PopoverNavigationLink, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
});
var menuTimeouts = {};
export var NavBar = function NavBar(_ref2) {
  var _ref2$forceState = _ref2.forceState,
      forceState = _ref2$forceState === void 0 ? null : _ref2$forceState,
      _ref2$defaultMenuStat = _ref2.defaultMenuState,
      defaultMenuState = _ref2$defaultMenuStat === void 0 ? {} : _ref2$defaultMenuStat;
  var t = useT();

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  var layoutContext = useLayoutContext();
  var navBarBackground = layoutContext.navBarBackground,
      navBarTextColor = layoutContext.navBarTextColor,
      navBarBleed = layoutContext.navBarBleed;
  var user = useCurrentUser();

  var _React$useState = React.useState('loading'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      userState = _React$useState2[0],
      setUserState = _React$useState2[1];

  var _React$useState3 = React.useState(defaultMenuState),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      menuState = _React$useState4[0],
      setMenuState = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      sideMenuOpen = _React$useState6[0],
      setSideMenuOpened = _React$useState6[1];

  var scrollPos = useScrollYPosition();
  var mounted = React.useRef(true);
  var router = useRouter();
  var openSideMenu = React.useCallback(function () {
    document.body.classList.add('sidepanel-active');
    window.addEventListener('keydown', handleKey, true); // eslint-disable-line no-use-before-define

    window.addEventListener('resize', handleResize, false); // eslint-disable-line no-use-before-define

    sendEvent({
      eventCategory: "Frodor - ".concat(TRACK_CAT),
      eventAction: 'click',
      eventLabel: 'Open Menu - side'
    });
    setSideMenuOpened(true);
  }, []);
  React.useEffect(function () {
    // focus side menu when opened
    if (sideMenuOpen) {
      var el = document.getElementById('nav-sidemenu');
      el === null || el === void 0 ? void 0 : el.focus();
    }
  }, [sideMenuOpen]);
  var closeSideMenu = React.useCallback(function () {
    document.body.classList.remove('sidepanel-active');
    window.removeEventListener('keydown', handleKey, false); // eslint-disable-line no-use-before-define

    window.removeEventListener('resize', handleResize, false); // eslint-disable-line no-use-before-define

    sendEvent({
      eventCategory: "Frodor - ".concat(TRACK_CAT),
      eventAction: 'click',
      eventLabel: 'Close Menu - side'
    });
    setSideMenuOpened(false);
  }, []);

  var openMenu = function openMenu(key) {
    setMenuState(_defineProperty({}, key, true)); // closes all other menus

    sendEvent({
      eventCategory: "Frodor - ".concat(TRACK_CAT),
      eventAction: 'click',
      eventLabel: "Open Menu - ".concat(key)
    });
  };

  var closeMenu = function closeMenu(key) {
    if (!mounted.current) return;
    setMenuState(function (curState) {
      return _objectSpread(_objectSpread({}, curState), {}, _defineProperty({}, key, false));
    });
    sendEvent({
      eventCategory: "Frodor - ".concat(TRACK_CAT),
      eventAction: 'click',
      eventLabel: "Close Menu - ".concat(key)
    });
  }; // event handlers for dropdown menus


  var getMenuHandlers = function getMenuHandlers(key) {
    return {
      onMouseEnter: function onMouseEnter() {
        // open menu and clear timeouts
        var to = menuTimeouts[key];

        if (to) {
          clearTimeout(to);
          delete menuTimeouts[key];
        }

        openMenu(key);
      },
      onMouseLeave: function onMouseLeave() {
        // close menu on delay for usability
        menuTimeouts[key] = setTimeout(function () {
          return closeMenu(key);
        }, MENU_CLOSE_DELAY);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === ' ') {
          e.preventDefault();

          if (menuState[key]) {
            closeMenu(key);
          } else {
            openMenu(key);
          }
        }
      },
      onClick: function onClick() {
        if (!menuState[key]) {
          openMenu(key);
        }
      }
    };
  };

  React.useEffect(function () {
    var handleChangeRouter = function handleChangeRouter() {
      closeSideMenu();
    };

    router.events.on('routeChangeStart', handleChangeRouter);
    return function () {
      router.events.off('routeChangeStart', handleChangeRouter);
    };
  }, [router.events, closeSideMenu]);
  React.useEffect(function () {
    return function () {
      document.body.classList.remove('sidepanel-active');
      mounted.current = false;
    };
  }, []); // set state of nav bar based on current user, or use 'forceState' if specified

  React.useEffect(function () {
    if (forceState) {
      setUserState(forceState);
      return;
    }

    setUserState(user ? user.hasAccess && 'claimed' || 'unclaimed' : user === undefined && 'loading' || 'loggedOut');
  }, [user]);
  var handleKey = React.useCallback(function (e) {
    if (e.key === 'Escape') {
      closeSideMenu();
    }
  }, []);
  var handleResize = React.useCallback(function () {
    if (window.innerWidth >= SIDE_MENU_TRIGGER_BREAKPOINT) {
      closeSideMenu();
    }
  }, []);
  var showLogin = userState === 'loggedOut';
  var showLogout = userState === 'claimed' || userState === 'unclaimed';
  var showDashboard = userState === 'claimed';
  var showClaim = userState === 'unclaimed' || userState === 'loggedOut';
  return /*#__PURE__*/_jsxs(NavBarWrapper, {
    customBackground: navBarBackground,
    customTextColor: navBarTextColor,
    bleed: navBarBleed,
    isScrolling: scrollPos !== 0,
    "data-testid": "navbar-state-".concat(userState),
    children: [/*#__PURE__*/_jsx(LogoArea, {
      children: /*#__PURE__*/_jsx(Link, {
        track: [TRACK_CAT, 'Logo'],
        href: "/?ref=logo",
        highlight: true,
        "data-testid": "navigation-logo",
        children: /*#__PURE__*/_jsx(ResponsiveLogo, {})
      })
    }), /*#__PURE__*/_jsx(LinksArea, {
      children: /*#__PURE__*/_jsxs("ul", {
        id: "menu-links",
        children: [/*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MenuLink, {
            children: /*#__PURE__*/_jsx(Link, {
              track: [TRACK_CAT, 'Features'],
              href: "/features",
              "data-testid": "navigation-features",
              children: t('FRODOR_3d7a71', 'Features', '')
            })
          })
        }), isHelpLive && /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MenuLink, {
            children: /*#__PURE__*/_jsx(Link, {
              track: [TRACK_CAT, 'Help'],
              href: "/help",
              "data-testid": "navigation-help",
              children: t('FRODOR_1d93a2', 'Help', '')
            })
          })
        }), /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MenuCategory, {
            children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
              "data-testid": "navigation-menu-resources"
            }, getMenuHandlers('resources')), {}, {
              children: /*#__PURE__*/_jsx(PopoverTrigger, {
                onShow: function onShow() {},
                onHide: function onHide() {},
                placement: PopoverTrigger.bottom,
                overlay: menuState.resources && /*#__PURE__*/_jsxs(PopoverNavigation, {
                  arrow: PopoverNavigation.top,
                  children: [/*#__PURE__*/_jsx(PopoverNavigationItem, {
                    children: /*#__PURE__*/_jsx(Link, {
                      "data-testid": "navigation-videos",
                      track: [TRACK_CAT, 'Videos'],
                      href: "/videos",
                      component: MenuCategoryLink,
                      children: t('FRODOR_9950ea', 'Videos', '')
                    })
                  }), /*#__PURE__*/_jsx(PopoverNavigationItem, {
                    children: /*#__PURE__*/_jsx(Link, {
                      "data-testid": "navigation-blog",
                      track: [TRACK_CAT, 'Blog'],
                      href: "/blog",
                      component: MenuCategoryLink,
                      children: t('FRODOR_278509', 'News', '')
                    })
                  }), /*#__PURE__*/_jsx(PopoverNavigationItem, {
                    children: /*#__PURE__*/_jsx(Link, {
                      "data-testid": "navigation-events",
                      track: [TRACK_CAT, 'Events'],
                      href: "/events",
                      component: MenuCategoryLink,
                      children: t('FRODOR_5172ce', 'Events', '')
                    })
                  }), /*#__PURE__*/_jsx(PopoverNavigationItem, {
                    children: /*#__PURE__*/_jsx(Link, {
                      "data-testid": "navigation-promocards",
                      track: [TRACK_CAT, 'Promo Cards'],
                      href: "/promocards",
                      component: MenuCategoryLink,
                      children: t('FRODOR_3697de', 'Promo Cards', 'Promo is short for promotional')
                    })
                  })]
                }),
                children: /*#__PURE__*/_jsxs(ButtonIcon, {
                  children: [/*#__PURE__*/_jsx("span", {
                    children: t('FRODOR_e8bb44', 'Resources', '')
                  }), menuState.resources ? /*#__PURE__*/_jsx(IconChevronUp, {
                    iconSize: 16,
                    "aria-label": t('FRODOR_04818c', 'Close resources menu', '')
                  }) : /*#__PURE__*/_jsx(IconChevronDown, {
                    iconSize: 16,
                    "aria-label": t('FRODOR_4203b1', 'Open resources menu', '')
                  })]
                })
              })
            }))
          })
        }), /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MenuLink, {
            children: /*#__PURE__*/_jsx(Link, {
              track: [TRACK_CAT, 'Providers'],
              href: "/providers",
              "data-testid": "navigation-providers",
              prefetch: false,
              children: t('FRODOR_83327b', 'Providers', '')
            })
          })
        }), USE_SEARCH && /*#__PURE__*/_jsx(RequireFeatureFlag, {
          flag: "s4a-frodor-test",
          fallback: /*#__PURE__*/_jsx(_Fragment, {}),
          waiting: /*#__PURE__*/_jsx(_Fragment, {}),
          children: /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(MenuLink, {
              children: /*#__PURE__*/_jsx(Link, {
                track: [TRACK_CAT, 'Search'],
                href: "/search",
                highlight: true,
                "data-testid": "navigation-search",
                prefetch: false,
                children: /*#__PURE__*/_jsx(IconSearch, {})
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ActionsArea, {
      hidden: userState === 'loading',
      children: /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx(NavBarLanguageItem, {}), showLogin && /*#__PURE__*/_jsx(StyledListItemNoMargin, {
          color: navBarTextColor,
          children: /*#__PURE__*/_jsx(LoginButton, {
            "data-testid": "root-login",
            highlight: true,
            track: [TRACK_CAT, 'Log In'],
            href: "".concat(getAccountsDomain(), "/login?continue=").concat(encodeURIComponent(window.location.href)),
            prefetch: false,
            children: t('FRODOR_284ac7', 'Log in', '')
          })
        }), showLogout && /*#__PURE__*/_jsx(StyledListItemNoMargin, {
          color: navBarTextColor,
          children: /*#__PURE__*/_jsx(LoginButton, {
            "data-testid": "root-logout",
            highlight: true,
            track: [TRACK_CAT, 'Log Out'],
            href: "".concat(getAccountsDomain(), "/logout?continue=").concat(encodeURIComponent(window.location.href)),
            prefetch: false,
            children: t('FRODOR_4253b5', 'Log out', '')
          })
        }), showClaim && /*#__PURE__*/_jsx(StyledListItemWithMargin, {
          color: navBarTextColor,
          children: /*#__PURE__*/_jsx(ClaimButton, {
            "data-testid": "navigation-claim",
            highlight: true,
            track: [TRACK_CAT, "Get Access (".concat(userState, ")")],
            href: "/claim",
            prefetch: false,
            children: t('FRODOR_7b3ef2', 'Get access', '')
          })
        }), showDashboard && /*#__PURE__*/_jsx(StyledListItemWithMargin, {
          color: navBarTextColor,
          children: /*#__PURE__*/_jsx(ClaimButton, {
            track: [TRACK_CAT, 'Dashboard'],
            href: "/c",
            highlight: true,
            "data-testid": "navigation-dashboard",
            prefetch: false,
            children: t('FRODOR_a7d070', 'Dashboard', '')
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MenuButtonArea, {
      children: /*#__PURE__*/_jsx(SideMenuLanguageOnboarding, {
        children: /*#__PURE__*/_jsx(OpenSideMenuButton, {
          tabIndex: 0,
          onKeyDown: function onKeyDown(e) {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();

              if (sideMenuOpen) {
                closeSideMenu();
              } else {
                openSideMenu();
              }
            }
          },
          onClick: function onClick() {
            return openSideMenu();
          },
          "data-testid": "navigation-sidemenu-trigger",
          "aria-label": t('FRODOR_NAV_RESPONSIVE_OPEN', 'Open navigation menu', 'open navigation menu in responsive display')
        })
      })
    }), sideMenuOpen && /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsx(NavSideMenu, {
        userState: userState,
        onClose: function onClose() {
          return closeSideMenu();
        }
      }), /*#__PURE__*/_jsx(Backdrop, {
        onClick: function onClick() {
          return closeSideMenu();
        }
      })]
    })]
  });
};